import React from "react";
import Donate from "../../components/donate/Donate";
import Contact from "../../components/contact/Contact";
import Footer from "../../components/footer";
import NavComponent from "../../components/navbar/index";
import ResumeClinicEventDetailsAndRSVP from "../../components/event-rsvp/resume-clinic";

const ResumeClinic = () => {
  return (
    <>
      <NavComponent />
      <div
        style={{
          marginTop: "80px",
        }}
      >
        <ResumeClinicEventDetailsAndRSVP />
      </div>
      <div
        style={{
          marginTop: "80px",
        }}
      >
        <Donate />
      </div>
      <Contact />
      <Footer />
    </>
  );
};

export default ResumeClinic;
